module.exports = __webpack_public_path__ + "img/医疗管理 智慧一体.51c0a276.png";